import { parse, SEPARATOR_PATTERN } from "@jsr/std__path";
import * as posix from "@jsr/std__path/posix";
import { FileTree } from "../types/filetree.js";
import { FileIgnoreRules } from "./ignore.js";
const nullFile = {
  size: 0,
  stream: new ReadableStream({
    start (controller) {
      controller.close();
    }
  }),
  text: ()=>Promise.resolve(''),
  readBytes: async (size, offset)=>new Uint8Array(),
  parent: new FileTree('', '/'),
  viewed: false
};
export function pathToFile(path, ignored = false) {
  const name = path.split('/').pop();
  return {
    name,
    path,
    ignored,
    ...nullFile
  };
}
export function pathsToTree(paths, ignore) {
  const ignoreRules = new FileIgnoreRules(ignore ?? []);
  return filesToTree(paths.map((path)=>pathToFile(path, ignoreRules.test(path))));
}
export function filesToTree(fileList, ignore) {
  ignore = ignore ?? new FileIgnoreRules([]);
  const tree = new FileTree('/', '/');
  for (const file of fileList){
    const parts = parse(file.path);
    if (parts.dir === '/') {
      tree.files.push(file);
      file.parent = tree;
      continue;
    }
    let current = tree;
    for (const level of parts.dir.split(SEPARATOR_PATTERN).slice(1)){
      const exists = current.get(level);
      if (exists) {
        current = exists;
        continue;
      }
      const newTree = new FileTree(posix.join(current.path, level), level, current, ignore);
      current.directories.push(newTree);
      current = newTree;
    }
    current.files.push(file);
    file.parent = current;
  }
  return tree;
}
//# sourceMappingURL=filetree.js.map